import { useEffect, useRef } from 'react';
import { ScrollSmoother } from 'gsap/ScrollSmoother';

export function useScrollSmootherLock(locked: boolean) {
  const scrollYRef = useRef(0);

  useEffect(() => {
    const smoother = ScrollSmoother.get();
    if (!smoother) return;

    const prevent = (e: Event) => e.preventDefault();

    if (locked) {
      scrollYRef.current = smoother.scrollTop();

      smoother.paused(true);

      window.addEventListener('wheel', prevent, { passive: false });
      window.addEventListener('touchmove', prevent, { passive: false });
      window.addEventListener('keydown', preventKeys, { passive: false });

      return () => {
        smoother.scrollTop(scrollYRef.current);
        smoother.paused(false);

        window.removeEventListener('wheel', prevent);
        window.removeEventListener('touchmove', prevent);
        window.removeEventListener('keydown', preventKeys);
      };
    }
  }, [locked]);
}

function preventKeys(e: KeyboardEvent) {
  if (
    e.key === 'ArrowDown' ||
    e.key === 'ArrowUp' ||
    e.key === 'PageDown' ||
    e.key === 'PageUp' ||
    e.key === 'Home' ||
    e.key === 'End' ||
    e.key === ' '
  ) {
    e.preventDefault();
  }
}
